<template>
  <div>
    <div style="display: flex;justify-content: space-between;padding-right: 45px;">
      <h3 style="margin-bottom: 10px;"># 话题列表</h3>
      <div>
        <el-input v-model.trim="subJectselectInputData" style="width: 200px;" size="small"
          placeholder="输入话题名查询"></el-input>
        <el-button style="margin-left: 2px;" icon="el-icon-search" size="small" type="primary"
          @click="subJectseletcSubmitFn"></el-button>
        <el-button icon="el-icon-plus" size="small" style="margin-left: 50px;" type="primary"
          @click="handleEdit('add', '')">添加话题</el-button>
      </div>
    </div>
    <el-table :data="subJectTableData" style="width: 100%">
      <el-table-column prop="id" label="话题ID" width="150" align="center">
      </el-table-column>

      <el-table-column prop="subjectName" label="话题昵称" align="center">
      </el-table-column>

      <el-table-column prop="createTime" label="话题添加日期" width="260" align="center">
      </el-table-column>

      <el-table-column prop="topState" label="置顶状态" width="200" align="center">
        <template slot-scope="scope">
          <span style="margin-right: 10px;">{{ scope.row.topState ? ' 置顶' : ' 不置顶' }}</span><el-switch :active-value="1"
            @change="topStateChangeFn(scope.row, $event)" :inactive-value="0" v-model="scope.row.topState">
          </el-switch>
        </template>
      </el-table-column>

      <el-table-column label="话题状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.subjectState == 0 ? '' : 'danger'">
            {{ scope.row.subjectState == 0 ? '展示' : '关闭' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit('edit', scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right;margin-top: 10px;">
      <el-pagination @current-change="currenChange" layout="prev, pager, next" :total="total_pages">
      </el-pagination>
    </div>

    <!-- 新增话题弹出框 -->
    <el-dialog :append-to-body="true" title="提示" :visible.sync="centerDialogVisible" width="30%" center>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="话题名称" prop="subjectName">
          <el-input v-model="ruleForm.subjectName"></el-input>
        </el-form-item>
        <el-form-item label="置顶状态" prop="topState">
          <el-select v-model="ruleForm.topState" placeholder="置顶状态">
            <el-option label="不置顶" :value="0"></el-option>
            <el-option label="置顶" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="话题状态" prop="subjectState">
          <el-select v-model="ruleForm.subjectState" placeholder="话题状态">
            <el-option label="展示" :value="0"></el-option>
            <el-option label="关闭" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { GetSubjectList, setSubjectApi, removeSubject, SetSubjectDataApi, QueryPointSubjectList } from '@/api/user'
export default {
  name: 'subJect',
  data() {
    return {
      subJectTableData: [],
      searchForm: {
        pageNum: 1,
        pageSize: 10
      },
      total_pages: 1,
      centerDialogVisible: false,
      subJectVal: '',
      ruleForm: {
        subjectName: '',
        topState: 0,
        subjectState: 0,
      },
      rules: {
        subjectName: [
          { required: true, message: '请输入话题名称', trigger: 'blur' }
        ],
        topState: [
          { required: true, message: '是否置顶', trigger: 'change' }
        ]
      },
      subJectselectInputData: ''
    }
  },
  mounted() {
    this.getList();
  }, 
  methods: {
    // 编辑话题
    handleEdit(type, row) {
      if (type == 'add') {
        this.ruleForm = {
          subjectName: '',
          topState: 0,
          subjectState: 0,
        }
        this.centerDialogVisible = true
        return
      }
      this.ruleForm = JSON.parse(JSON.stringify(row))
      this.centerDialogVisible = true
    },
    getList() {
      GetSubjectList(this.searchForm).then(res => {
        this.subJectTableData = res.data.records
        this.total_pages = res.data.total
      })
    },
    // 删除话题
    async handleDelete(rows) {
      this.$confirm('此操作将删除该话题, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeSubject(rows.id).then(res => {
          this.$message.success("删除成功")
          this.getList()
        })
      }).catch(e => {
        this.$message.error(e ? e : '操作失败')
      })

    },
    // 修改话题置顶状态
    async topStateChangeFn(row, e) {
      let options = { ...row, topState: e }
      setSubjectApi(options).then(res => {
        if (res.code == 200) {
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => { this.$message.error(err ? err : '操作失败') })
    },
    // 分页被单击
    async currenChange(pages) {
      this.searchForm.pageNum = pages
      this.getList()
    },
    // 新增话题
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          SetSubjectDataApi(this.ruleForm).then(res => {
            this.getList()
            this.centerDialogVisible = false
          })
        }
      })
    },
    // 搜索话题
    subJectseletcSubmitFn() {
      this.getList();

    }
  }
}
</script>

<style></style>
